
export function findLiveBookingListEntry(bookingsList, bookingId) {
	if (!Array.isArray(bookingsList) || bookingsList.length === 0 || !bookingId) return null;
	const targetId = String(bookingId);
	return (
		bookingsList.find((b) => {
			const bId = String(b?.booking_id || b?.id || '');
			return bId === targetId && bId !== '';
		}) || null
	);
}

export function buildLiveGuestTagMap(bookingItemMap) {
	const map = {};
	if (bookingItemMap && typeof bookingItemMap === 'object') {
		Object.values(bookingItemMap).forEach((bookings) => {
			if (!Array.isArray(bookings)) return;
			bookings.forEach((item) => {
				const itemId = item?.id ?? item?.booking_item_id;
				if (itemId != null) {
					map[itemId] = item;
				}
			});
		});
	}
	return map;
}

const resolveGuestNameParts = (liveItem, item) => {
	const first = liveItem?.guest_first_name ?? item?.guest_first_name;
	const last = liveItem?.guest_last_name ?? item?.guest_last_name;
	if ((first != null && first !== '') || (last != null && last !== '')) {
		return { guest_first_name: first ?? null, guest_last_name: last ?? null };
	}
	const checkinName = liveItem?.guest_checkin_name ?? item?.guest_checkin_name;
	if (checkinName && String(checkinName).trim()) {
		const parts = String(checkinName).trim().split(/\s+/);
		return {
			guest_first_name: parts[0] ?? null,
			guest_last_name: parts.slice(1).join(' ') || null,
		};
	}
	return { guest_first_name: first ?? null, guest_last_name: last ?? null };
};

export function isPrimaryItem(item) {
	if (!item) return false;
	const additional = item.additional && typeof item.additional === 'object' ? item.additional : null;
	const flag = item.primary ?? additional?.primary;
	return flag === 1 || flag === true || flag === '1';
}

export function isPrimaryCustomerGroup(customerName, bookings, primaryUserName) {
	if (Array.isArray(bookings) && bookings.some((item) => isPrimaryItem(item))) return true;
	return Boolean(primaryUserName) && customerName === primaryUserName;
}

export function resolvePrimaryCustomerBookings(customerBookingItems, primaryUserName) {
	if (!customerBookingItems || typeof customerBookingItems !== 'object') return null;
	if (primaryUserName) {
		const byName = customerBookingItems[primaryUserName];
		if (Array.isArray(byName) && byName.length > 0) return byName;
	}
	const primaryEntry = Object.entries(customerBookingItems).find(
		([, bookings]) => Array.isArray(bookings) && bookings.some((b) => Number(b?.primary) === 1)
	);
	if (primaryEntry) return primaryEntry[1];
	const firstKey = Object.keys(customerBookingItems)[0];
	const first = firstKey ? customerBookingItems[firstKey] : null;
	return Array.isArray(first) && first.length > 0 ? first : null;
}

export function mergeLiveGuestTagIntoItem(item, liveMap) {
	const itemId = item?.id ?? item?.booking_item_id;
	const liveItem = itemId != null ? liveMap?.[itemId] : null;
	if (!liveItem) return item;
	const pick = (key) => (liveItem[key] !== undefined ? liveItem[key] : item?.[key]);
	const names = resolveGuestNameParts(liveItem, item);
	return {
		...item,
		guest_checkin_id: pick('guest_checkin_id') ?? null,
		guest_first_name: names.guest_first_name,
		guest_last_name: names.guest_last_name,
		below_12: pick('below_12'),
		checkin_required: pick('checkin_required'),
		checkin_exempt_reason: pick('checkin_exempt_reason'),
	};
}

export function mergeLiveGuestTagIntoBookingItemMap(bookingItemMap, liveMap) {
	if (!bookingItemMap || typeof bookingItemMap !== 'object') return bookingItemMap;
	const result = {};
	Object.entries(bookingItemMap).forEach(([customerName, bookings]) => {
		result[customerName] = Array.isArray(bookings)
			? bookings.map((item) => mergeLiveGuestTagIntoItem(item, liveMap))
			: bookings;
	});
	return result;
}
